// extracted by mini-css-extract-plugin
export default {"generalPopupContentContainer":"generalPopupContentContainer--t1D7F","title":"title--Bgdu_","link":"link--EPo51","okBtnContainer":"okBtnContainer--vgMah","okBtn":"okBtn--hygwk"};